/**
 * Profile Components Constants
 *
 * Centralized configuration for profile components to avoid magic numbers
 * and improve maintainability.
 */

// Tooltip and truncation thresholds
export const PROFILE_CONSTANTS = {
  // Character threshold for showing tooltips in ProfileMetadataRow and ProfileNameRow
  TOOLTIP_CHAR_THRESHOLD: 20,

  // Default maximum width for truncated content
  DEFAULT_MAX_WIDTH: 'max-w-[200px]',

  // Default fallback text for ProfileNameRow
  DEFAULT_FALLBACK_TEXT: 'DATA NEEDED',

  // Default avatar size
  DEFAULT_AVATAR_SIZE: 'h-11 w-11',

  // Icon sizes for profile metadata
  ICON_SIZES: {
    SMALL: 'h-3 w-3',
    MEDIUM: 'h-4 w-4',
    LARGE: 'h-5 w-5',
  },

  // Icon colors for consistency
  ICON_COLORS: {
    GREY_5: 'text-grey-5',
    GREY_6: 'text-grey-6',
    GREY_7: 'text-grey-7',
  },
} as const;

// Platform-specific configuration for ProfileHandle
export const PLATFORM_CONFIG = {
  // Platforms that should show @ prefix
  WITH_AT_PREFIX: ['instagram', 'pinterest', 'tiktok'] as const,

  // Platforms that should not show @ prefix
  WITHOUT_AT_PREFIX: ['youtube', 'facebook'] as const,
} as const;

// Type helpers
export type PlatformWithAtPrefix = typeof PLATFORM_CONFIG.WITH_AT_PREFIX[number];
export type PlatformWithoutAtPrefix = typeof PLATFORM_CONFIG.WITHOUT_AT_PREFIX[number];
